import {useAnalytics} from '@github-ui/use-analytics'
import {useCallback} from 'react'

import {buildCopilotUpdateIssueUrl} from '../utils/build-copilot-update-issue-url'

interface CommentForCopilotUpdate {
  url: string
  body: string
  id: string
  repository: {
    name: string
    owner: {
      login: string
    }
  }
}

/**
 * Hook to handle updating an issue body using GitHub Copilot.
 * Extracts the issue number from the comment URL, sends analytics, and opens Copilot chat.
 */
export function useUpdateIssueFromCommentWithCopilot() {
  const {sendAnalyticsEvent} = useAnalytics()

  const updateIssueWithCopilot = useCallback(
    (comment: CommentForCopilotUpdate) => {
      // Extract issue number from comment URL (e.g., /owner/repo/issues/123#issuecomment-456)
      const issueNumberMatch = comment.url.match(/\/issues\/(\d+)/)
      const issueNumber = issueNumberMatch ? issueNumberMatch[1] : ''

      if (!issueNumber) {
        return
      }

      // Send analytics event
      sendAnalyticsEvent('analytics.click', 'COPILOT_COMMENT_UPDATE_ISSUE_BUTTON', {
        commentId: comment.id,
        issueNumber,
        repoNWO: `${comment.repository.owner.login}/${comment.repository.name}`,
      })

      // Build Copilot URL with encoded prompt
      const copilotUrl = buildCopilotUpdateIssueUrl({
        ownerLogin: comment.repository.owner.login,
        repoName: comment.repository.name,
        issueNumber,
        commentBody: comment.body,
      })
      window.open(copilotUrl, '_blank')
    },
    [sendAnalyticsEvent],
  )

  return {updateIssueWithCopilot}
}
